export default __webpack_public_path__ + "0452df64504836083288582a8262725a.svg";